export default {"src":"/_next/static/media/spotify.cf33418c.svg","height":44,"width":180,"blurWidth":0,"blurHeight":0};